import axios from "axios";

function parseCookie(header) {
  let cookie = header.get("Set-Cookie");
  if (!cookie) return null;
  let PHPSESSID = cookie[0].split(";")[0];
  return PHPSESSID;
}

export default async function login({ schoolId, schoolCode, password }) {
  try {
    const data = {};
    if (schoolCode && password) {
      data.school_code = schoolCode;
      data.password = password;
    } else {
      if (!schoolId) throw new Error("School ID is required");
      data.schoolId = schoolId;
    }

    // Creating a new URLSearchParams object
    const params = new URLSearchParams(data);

    // Appending data to the URLSearchParams object
    // for (const [key, value] of Object.entries(data)) {
    //   params.append(key, value);
    // }
    const url = "https://router.shsadmissions.com/loginapi/hm_login_ajax";
    const { headers, data: result } = await axios(url, {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: params,
      withCredentials: true,
    });
    if (result.status == "success") return parseCookie(headers);
    throw new Error("Invalid credentials");
  } catch (error) {
    throw error;
  }
}

export async function findUnenrolledStudent(
  { schoolCode, indexNumber, schoolId },
  cookie,
  calledOnce
) {
  try {
    // Data to be URL encoded
    const data = {
      school_code: schoolCode,
      student_index: indexNumber,
    };

    // Creating a new URLSearchParams object
    const params = new URLSearchParams();

    // Appending data to the URLSearchParams object
    for (const [key, value] of Object.entries(data)) {
      params.append(key, value);
    }

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    if (cookie) headers.Cookie = cookie;
    // Set dummy cookie
    const url = "https://router.shsadmissions.com/sysapi/enroll_find_student";
    const { data: result } = await axios(url, {
      method: "post",
      headers,
      data: params,
      withCredentials: true,
    });

    // Student is found
    if (result.status && result.status == "success")
      return { type: "found", student: result.students[0] };

    if (result.status && result.status == "failed") {
      return { type: "notFound" };
    }

    if (result.status == "exists") {
      return { type: "exists" };
    }

    if (result.get || result.not) {
      if (calledOnce) throw new Error("Unable to connect to CSSPS");
      //   Authentication required. Login and try again
      cookie = await login({ schoolId });
      return await findUnenrolledStudent(
        { schoolCode, indexNumber, schoolId },
        cookie,
        true
      );
    }
    return { type: "unexpectedError" };
  } catch (error) {
    throw error;
  }
}

export async function findEnrolledStudent(
  { schoolId, schoolCode, indexNumber },
  cookie,
  calledOnce
) {
  try {
    // Data to be URL encoded
    const data = {
      school_code: schoolCode,
      indexno: indexNumber,
    };

    // Creating a new URLSearchParams object
    const params = new URLSearchParams();

    // Appending data to the URLSearchParams object
    for (const [key, value] of Object.entries(data)) {
      params.append(key, value);
    }
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    if (cookie) headers.Cookie = cookie;
    const url =
      "https://router.shsadmissions.com/sysapi/enrollment_find_student";
    const { data: result } = await axios(url, {
      method: "post",
      headers,
      data: params,
      withCredentials: true,
    });

    if (result.get || result.not) {
      if (calledOnce) throw new Error("Unable to connect to CSSPS");
      //   Authentication required. Login and try again
      cookie = await login({ schoolId });
      return await findEnrolledStudent(
        { schoolCode, indexNumber, schoolId },
        cookie,
        true
      );
    }

    if (result.it && result.it == "failed") {
      if (calledOnce) return { type: "notFound" };
      //   Authentication required. Login and try again
      cookie = await login({ schoolId });
      return await findEnrolledStudent(
        { schoolCode, indexNumber, schoolId },
        cookie,
        true
      );
    }
    if (result.it && result.it == "worked") {
      return { type: "found", student: result.pl_obj };
    }

    if (calledOnce) return { type: "unexpectedError" };
    //   Authentication required. Login and try again
    cookie = await login({ schoolId });
    return await findEnrolledStudent(
      { schoolCode, indexNumber, schoolId },
      cookie,
      true
    );
  } catch (error) {
    throw error;
  }
}

export async function enroll(
  { schoolId, schoolCode, indexNumber },
  cookie,
  calledOnce
) {
  try {
    // Check if student is already enrolled
    let enrolledStudent = await findEnrolledStudent({
      schoolId,
      schoolCode,
      indexNumber,
    });

    if (enrolledStudent.type == "found") {
      // Student already enrolled
      return { status: "exists" };
    }

    // Student not enrolled
    // Check if student is in unenrolled list
    let unEnrolledStudent = await findUnenrolledStudent({
      schoolCode,
      indexNumber,
      schoolId,
    });

    if (unEnrolledStudent.type == "notFound") {
      throw new Error(
        "Student not found. Might have been placed in another school"
      );
    }

    if (unEnrolledStudent.type == "exists") {
      return { status: "exists" };
    }

    if (unEnrolledStudent.type == "unexpectedError") {
      throw new Error(
        "Ooops, an unexpected error occured. Please try again later"
      );
    }

    // Student is found at this point
    const { student } = unEnrolledStudent;

    // Enroll Student
    // Data to be URL encoded
    const data = {
      school_code: schoolCode,
      indexno: indexNumber,
      enrollment_code: student.enrollment_code,
      student_name: student.name,
      student_gender: student.gender,
      program: student.programme,
      dtrack: student.dtrack,
      residency: student.residency,
      prog_code: student.programme_code,
    };

    // Creating a new URLSearchParams object
    const params = new URLSearchParams();

    // Appending data to the URLSearchParams object
    for (const [key, value] of Object.entries(data)) {
      params.append(key, value);
    }

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    if (cookie) headers.Cookie = cookie;
    const url =
      "https://router.shsadmissions.com/sysapi/actually_enroll_student";
    const { data: result } = await axios(url, {
      method: "post",
      headers,
      data: params,
      withCredentials: true,
    });

    if (!result.message || result.message.toLowerCase() != "student enrolled") {
      //
      if (calledOnce) throw new Error("Unable to connect to CSSPS");
      //   Authentication required. Login and try again
      cookie = await login({ schoolId });
      return await enroll(
        {
          schoolId,
          schoolCode,
          indexNumber,
        },
        cookie,
        true
      );
    }

    return { status: "enrolled", enrollmentCode: student.enrollment_code };
  } catch (error) {
    throw error;
  }
}
